export default {
  name: 'marking--printUpload',
  apiService: 'shoes',
  apiPath: '/admin/print/func/upload',
  urlParamName: 'marking--printUpload',
};